import { patch, post, remove } from '@va/http-client';
import { getUserId } from '@va/standalone/shared/helpers';
import { selectAgencyUIId } from '@va/standalone/shared/selectors';
import { useAsyncFunction } from '@va/util/hooks';
import { useCallback } from 'react';
import { useSelector } from 'react-redux';

export const useUploadAgencyLogo = () => {
  const userId = getUserId();

  const asyncFn = useCallback(
    async (file: File) => {
      return post<{ fileId: string }>(`/users/${userId}/agencyui/logo`, {}, { file: file });
    },
    [userId],
  );

  return useAsyncFunction(asyncFn);
};

export const useDeleteAgencyLogo = () => {
  const agencyUIId = useSelector(selectAgencyUIId);
  const userId = getUserId();

  const asyncFn = useCallback(async () => {
    return remove<{ fileId: string }>(`/users/${userId}/agencyui/${agencyUIId}/logo`);
  }, [userId, agencyUIId]);

  return useAsyncFunction(asyncFn);
};

export const useEditAgencyUi = () => {
  const userId = getUserId();
  const agencyUIId = useSelector(selectAgencyUIId);
  const asyncFn = useCallback(
    async (data: any) => {
      return patch(`/users/${userId}/agencyui/${agencyUIId}`, {}, data);
    },
    [userId, agencyUIId],
  );

  return useAsyncFunction<typeof asyncFn>(asyncFn);
};
